module.exports = __webpack_public_path__ + "static/media/product-success.c8ab758c.svg";